<template>

    <div v-if="!submitted"
         class="flex flex-col justify-center min-h-full py-12 sm:px-6 lg:px-8">
        <div class="sm:mx-auto sm:w-full sm:max-w-md">
            <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">Reset Your Account Password</h2>
            <p class="mt-2 text-center text-sm text-gray-600">
                Your password must be at least 6 characters long and must contain at least one uppercase, one lowercase,
                and one numerical character.
            </p>
        </div>

        <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <div class="bg-white py-8 px-4 shadow-sm sm:rounded-lg sm:px-10">
                <form id="form-reset-password" class="space-y-6">
                    <ErrorSummary :response-status="responseStatus"/>
                    <div>
                        <label for="password" class="block text-sm font-medium text-gray-700"> Password </label>
                        <div class="mt-1">
                            <input v-model="password"
                                   id="password"
                                   name="password"
                                   type="password"
                                   required
                                   class="appearance-none block w-full px-3 py-2 border border-clay-500 rounded-md shadow-sm placeholder-gray-400 focus:outline-hidden focus:ring-electric-500 focus:border-electric-500 sm:text-sm">
                        </div>
                    </div>


                    <div>
                        <label for="repeatPassword" class="block text-sm font-medium text-gray-700"> Repeat
                            Password </label>
                        <div class="mt-1">
                            <input v-model="repeatPassword"
                                   id="repeatPassword"
                                   name="repeatPassword"
                                   type="password"
                                   required
                                   class="appearance-none block w-full px-3 py-2 border border-clay-500 rounded-md shadow-sm placeholder-gray-400 focus:outline-hidden focus:ring-electric-500 focus:border-electric-500 sm:text-sm">
                        </div>
                    </div>

                    <div>
                        <SaButton :disabled="!password || !repeatPassword" @click.prevent="submit" :loading="isSubmitting" variant="primary">
                            <template #loading>
                                Submitting...
                            </template>
                            Request Password Reset
                        </SaButton>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <div v-else class="flex flex-col justify-center min-h-full py-12 sm:px-6 lg:px-8">
        <div class="max-w-4xl mx-auto text-center pro-opp-checkout">
            <div class="space-y-3 ">
                <h1 class="text-3xl font-bold tracking-tight text-gray-900 md:text-4xl">Password Reset Successful!
                </h1>
                <p class="my-4 text-xl leading-6 text-clay-800">
                    Your password has been successfully reset.<br> You can now log in to your account by clicking the link below.
                </p>
                <p>
                    <a class="inline-flex items-center px-5 py-3 font-medium text-white uppercase border border-transparent rounded-md shadow-sm t bg-rose-500 hover:bg-rose-600 focus:outline-hidden focus:ring-2 focus:ring-rose-500 focus:ring-offset-2"
                       href="/login">Login</a>
                </p>
    
            </div>
        </div>
    </div>

</template>

<script lang="ts" setup>
// @ts-ignore
import {defineProps, ref} from "vue";
import {client} from '@/shared';
import {ResetPassword} from "@/dtos";
import ErrorSummary from "@/main/components/ErrorSummary.vue";
import SaButton from "@/main/components/SaButton.vue";

const props = defineProps({
    token: {
        default: ''
    }
})

const token = ref(props.token);
const password = ref('');
const repeatPassword = ref('');
const isSubmitting = ref(false);
const submitted = ref(false);
const responseStatus = ref(null);

const submit = async () => {
    isSubmitting.value = true;
    await client.post(new ResetPassword({
        token: token.value,
        password: password.value,
        repeatPassword: repeatPassword.value,
    }))
        .then(() => {
            submitted.value = true;
        })
        .catch(e => {
            responseStatus.value = e.responseStatus;
            window.scrollTo(0,100);
        });
    isSubmitting.value = false;
};
</script>